import React from "react";
import { Link } from "react-router-dom";
import { Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const Cart = () => {
  const { items, removeItem, updateQuantity, subtotal } = useCart();

  if (items.length === 0) {
    return (
      <div className="py-24 text-center max-w-md mx-auto px-5">
        <ShoppingBag size={56} className="mx-auto text-p3-muted mb-5" />
        <h1 className="font-heading font-bold text-2xl text-p3-navy mb-3">Your cart is empty</h1>
        <p className="text-p3-muted mb-6">Looks like you haven't added any services yet.</p>
        <Link to="/shop" className="inline-block bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold px-8 py-3 rounded-lg transition-all">
          Browse Shop
        </Link>
      </div>
    );
  }

  return (
    <div className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <h1 className="font-heading font-extrabold text-3xl text-p3-navy mb-8">Your Cart</h1>
        <div className="space-y-4 mb-10">
          {items.map((item) => (
            <div key={item.cartId} className="flex items-center gap-5 bg-p3-cream rounded-2xl p-5">
              <img src={item.image} alt={item.name} className="w-16 h-16 object-contain bg-white rounded-lg p-2" />
              <div className="flex-1">
                <h3 className="font-heading font-bold text-p3-navy">{item.name}</h3>
                <p className="text-xs text-p3-muted">{item.seoOption} &middot; {item.websiteOption}</p>
              </div>
              <input
                type="number"
                min={1}
                value={item.quantity}
                onChange={(e) => updateQuantity(item.cartId, parseInt(e.target.value) || 1)}
                className="w-16 px-2 py-2 rounded-lg border border-gray-200 text-sm text-center"
              />
              <p className="font-heading font-bold text-p3-navy w-24 text-right">${(item.price * item.quantity).toFixed(2)}</p>
              <button onClick={() => removeItem(item.cartId)} className="text-red-400 hover:text-red-600 transition-colors">
                <Trash2 size={18} />
              </button>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5 bg-p3-cream rounded-2xl p-6">
          <p className="font-heading font-bold text-xl text-p3-navy">Subtotal: ${subtotal.toFixed(2)}</p>
          <Link
            to="/checkout"
            className="bg-p3-navy hover:bg-p3-navy-dark text-white font-semibold px-8 py-3.5 rounded-lg transition-all"
          >
            Proceed to Checkout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
